// Structure du cours "Tempalte"
import courseImage from './course-image.jpg';

export const courseStructure = {
  id: 'snake',
  title: 'Jeu 4 : Snake',
  image: courseImage,
  chapters: [
    {
      id: 'introduction',
      title: 'Introduction',
      path: '/cours/snake'
    },
    {
      id: 'chapitre1',
      title: ' Idée générale et squelette',
      path: '/cours/snake/chapitre1'
    },
    {
      id: 'chapitre2',
      title: 'Déplacement du serpent',
      path: '/cours/snake/chapitre2'
    },
    {
      id: 'chapitre3',
      title: 'Ajout du corps',
      path: '/cours/snake/chapitre3'
    },
    {
      id: 'chapitre4',
      title: 'La nourriture',
      path: '/cours/snake/chapitre4'
    },
    {
      id: 'chapitre5',
      title: 'Collisions',
      path: '/cours/snake/chapitre5'
    },
    {
      id: 'chapitre6',
      title: 'Son et score',
      path: '/cours/snake/chapitre6'
    },
    
  ]
}; 